import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

import { NotificationListResponse } from '../models/ninety-notification.model';
import { NotificationFilterOptions } from '../models/notification-filter-options';

@Injectable({
  providedIn: 'root',
})
export class NotificationFeedApiService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT);

  private get apiUrl(): string {
    return `${this.environment.origin.notifications}/v1/notifications`;
  }

  getNotificationsInit(): Observable<NotificationListResponse> {
    return this.http.get<NotificationListResponse>(`${this.apiUrl}/init`);
  }

  getNotifications(
    filterBy: NotificationFilterOptions = NotificationFilterOptions.all,
    page = 1
  ): Observable<NotificationListResponse> {
    return this.http.get<NotificationListResponse>(`${this.apiUrl}?page=${page}&filter=${filterBy}`);
  }

  markNotificationsAsRead(ids: number[]): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/read`, { ids });
  }

  markNotificationAsUnread(id: number): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/unread`, {});
  }

  markNotificationAsOpened(id: number): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/opened/${id}`, {});
  }

  markAllAsRead(): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/read/all`, {});
  }
}
